const communities = [
  { name: "Discord", note: "Come hang out", description: "Ask a question, find an Arena rival, or show us the card you refuse to part with.", href: "https://discord.gg/u8rEkuk7G" },
  { name: "Reddit", note: "Compare notes", description: "Longer conversations, alpha feedback and stories from your little corner of the island.", href: "https://www.reddit.com/r/numgnums/" },
  { name: "Fandom wiki", note: "Find your feet", description: "A growing player guide, starting with the first five Numgnums. Discover something useful? Help the next person out.", href: "https://numgnums.fandom.com/wiki/Numgnums_Wiki" },
  { name: "YouTube", note: "See it moving", description: "Gameplay, little guides and a look at how this strange beach gets made.", href: "https://www.youtube.com/@numgnums" },
  { name: "Instagram", note: "A little island life", description: "Creature art, beach moments and things we’re working on.", href: "https://www.instagram.com/numgnums/" },
  { name: "Patreon", note: "Support the people making it", description: "Our home for following development and supporting the work. We’re still getting the page ready.", href: "https://www.patreon.com/c/numgnums" },
] as const;

export function SocialsPage() {
  return (
    <div className="socials-page">
      <header className="socials-intro">
        <p className="socials-eyebrow">Around the island</p>
        <h1>Pull up a<br />beach chair.</h1>
        <p>We’re making a strange little game. It gets better when people turn up, try things and tell us what happened. Here’s where to find us.</p>
      </header>
      <section className="socials-grid" aria-label="Official NUMGNUMS communities">
        {communities.map((community) => (
          <a className="socials-card" key={community.name} href={community.href} target="_blank" rel="noopener noreferrer">
            <span className="socials-eyebrow">{community.note}</span>
            <h2>{community.name}<span aria-hidden="true"> ↗</span></h2>
            <p>{community.description}</p>
            <span className="socials-visit">Visit {community.name}<span className="sr-only"> (opens in a new tab)</span></span>
          </a>
        ))}
      </section>
      <p className="socials-footnote">New to the alpha? Questions are welcome. If something breaks, your device, game version and what you were doing help us track it down.</p>
    </div>
  );
}
